import { CartaDeCorrecaoServiceAdapter } from '@/usecases/fiscal/adapter/CartaDeCorrecaoServiceAdapter';
import { injectable } from 'inversify';
import { criarCartaDeCorrecao, findCartasDeCorrecao } from '@/api/CartaDeCorrecao';
import { AxiosRequestConfig } from 'axios';


@injectable()
export class CartaDeCorrecaoService implements CartaDeCorrecaoServiceAdapter {
	criarCartaDeCorrecao = async (params?: any) => await criarCartaDeCorrecao(params);
	findCartasDeCorrecao = async (params?: any, config?: AxiosRequestConfig) => await findCartasDeCorrecao(params, config)
}	